// Entry point for the build script in your package.json

import './components/navigation-bar.js';
import './components/curriculum-selector.js';
import './components/player.js';
import './components/area-card.js';
import './components/pathway.js';
import './components/pathway-sidebar.js';
import './components/likert-question.js';
import './components/notice.js';
import './components/date-range.js';
import './components/table.js';
import './components/video-card.js';

import './pages/question.js';
import './pages/standard.js';
import './pages/search.js';
import './pages/pathway.js';
import './pages/analytics.js';

import 'mathjax-full/es5/tex-mml-chtml';

import { easepick } from '@easepick/bundle';
import { RangePlugin } from '@easepick/range-plugin';

import moment from 'moment';

MathJax.config.chtml.fontURL = '/fonts';
MathJax.config.chtml.font.options.fontURL = '/fonts'

window.easepick = easepick;
window.easepickPlugins = [
  RangePlugin
];
window.moment = moment;

window.atlas = window.atlas || {};

window.atlas.blockUI = () => {
  document.querySelector('#loading-screen').classList.remove('hidden');
};

window.atlas.unblockUI = () => {
  document.querySelector('#loading-screen').classList.add('hidden');
};
